// src/seo/homeSchemas.js — the JSON-LD the homepage <Helmet> emits: Service,
// FAQPage and SoftwareApplication.
//
// Single source for TWO emitters: src/pages/HomePage.js (Helmet, client +
// react-snap) and the post-build rescue in scripts/inject-seo-meta.js (loaded
// through scripts/load-esm.js). The react-snap/react-helmet-async race drops the
// homepage Helmet on a random subset of builds (2026-10-31 live: all three nodes
// missing while OfferCatalog/VideoObject — already rescued — were present). The
// rescue appends only what is missing, so both paths MUST produce byte-identical
// JSON; keeping the data here instead of inline in the page makes that
// structural rather than something a test has to re-check by hand.
// OfferCatalog and VideoObject live in trackerSchemas.json / videoSchemas.json
// for the same reason.
import { buildService, buildFAQ, buildSoftwareApplication, SITE_BASE } from './schemaBuilders';

export const HOME_FAQS = [
  { q: 'Wat kost GPS tracking bij FleetTrack Holland?', a: 'Vanaf €9,95 per voertuig per maand voor het Starter-pakket. Professional €14,95, Fleet op maat. Maandelijks opzegbaar, geen verborgen kosten.' },
  { q: 'Hoe snel kunnen jullie installeren?', a: 'U installeert de tracker zelf in enkele minuten: een OBD-stekker klikt u in de OBD-poort en een accu-tracker sluit u aan op de accupolen. U ontvangt de tracker per post.' },
  { q: 'Voldoen jullie aan de Belastingdienst-eisen voor rittenregistratie?', a: 'Ja. Onze rittenregistratie is sluitend conform artikel 52 AWR met automatische 7-jaars bewaarmodus.' },
  { q: 'Werken jullie alleen in Nederland?', a: 'Onze service-area is heel Nederland. Trackers werken in heel Europa (EU-roaming inbegrepen). De hardware is inbegrepen bij het abonnement.' },
  { q: 'Kan ik een gratis adviesgesprek krijgen?', a: 'Ja, vraag een gratis adviesgesprek aan via /offerte/ of mail naar info@fleettrackholland.nl. U krijgt op werkdagen binnen 24 uur reactie.' },
];

/** Umbrella Service offering (@id …/#service). */
export const homeServiceSchema = () => buildService({
  url: `${SITE_BASE}/`,
  serviceType: 'GPS tracking, rittenregistratie en fleet management',
  name: 'FleetTrack Holland — GPS Tracking voor het MKB',
  description: 'GPS tracking, automatische rittenregistratie en fleet management software voor het Nederlandse MKB. Vanaf €9,95 per voertuig per maand. Hardware inbegrepen bij het abonnement. Zelf installeren in enkele minuten.',
  startingPrice: 9.95,
  unit: 'voertuig per maand',
  audience: 'MKB en wagenparkbeheerders in Nederland',
});

/** Top conversion FAQs (no @id — deduplicated by full JSON in the rescue). */
export const homeFaqSchema = () => buildFAQ(HOME_FAQS);

/** SaaS product node (@id …/#softwareapplication — price rich result). */
export const homeSoftwareApplicationSchema = () => buildSoftwareApplication();

/** All three, in Helmet order. */
export const homeHelmetSchemas = () => [homeServiceSchema(), homeFaqSchema(), homeSoftwareApplicationSchema()];
